import elevatorTheme from './theme/elevatorTheme';

// Atoms
export * from './atoms';
export { default as ThemeToggle } from './atoms/ThemeToggle/ThemeToggle';
export type { ThemeToggleProps } from './atoms/ThemeToggle/ThemeToggle';

// Electrons
export * from './electrons';

// Molecules
export * from './molecules';

// Styles
export * from './styles';

// Constants
export * from './constants/campaigns';
export * from './constants/date';
export * from './constants/media';
export * from './constants/permissions';
export * from './constants/postStatuses';
export * from './constants/postTypes';
export * from './constants/socialMediaTypes';
export * from './constants/submissionStatuses';

// Hooks
export * from './hooks/useAuth';
export {
  useColorMode,
  ColorModeProvider,
  resolveHydrationColorMode,
  colorModeStorageManager,
  HYDRATION_COLOR_MODE_META,
} from './hooks/useColorMode';
export {
  COLOR_MODE_STORAGE_KEY,
  colorModeCookieName,
  colorModeBlockingScript,
  readColorModeFromCookieHeader,
} from './hooks/colorModeCookie';

// Lib
export * from './lib/auth';
export * from './lib/google/analytics';
export * from './lib/graphql/queries/user';
export * from './lib/graphql/mutations/media';
export * from './lib/graphql/apollo';

// Theme
export { default as elevatorTheme, lightTheme, darkTheme } from './theme/elevatorTheme';
// Not re-exported here: the site server bundle includes this barrel, and
// evaluating colorSchemeTheme loads @mui/system/cssVars when pages boot.
export * from './theme/palette';
export * from './theme/defaultProps';
export * from './theme/typography';

// Types
export * from './types/credit';
export * from './types/campaign';
export * from './types/generic';
export * from './types/graphql';
export * from './types/media';
export * from './types/order';
export * from './types/permissionGroup';
export * from './types/post';
export * from './types/socialMedia';
export * from './types/submission';
export * from './types/user';
export * from './types/variants';
export * from './types/palette';

// Utils
export * from './utils/auth';
export * from './utils/campaigns';
export * from './utils/string';
export * from './utils/colors';
export * from './utils/redirect';
export * from './utils/checkEnv';
export * from './utils/bugsnag';

// Import type augmentations (side-effect imports)
// These must be at the end to ensure all type exports are available first
/* eslint-disable import/first */
import './types/global';
import './types/mui';
/* eslint-enable import/first */
